import * as Ably from "ably";
import { BackedApi } from "../../../config/urls/Api";

export const realtimeClient = (channelName: string) => {
  return new Ably.Realtime({    
    authCallback: async (_, callback) => {
      const { url } = BackedApi.GetTokenRealTime(channelName);
      let tokenRequest = null;
      try {
        const response = await fetch(url, {
          method: "GET",
          credentials: "include",          
        });    
        tokenRequest = await response.json();        
      } catch (err) {        
        console.log("error get token realtime", err);
        throw new Error("Error to get token realtime");
      }
      callback(null, tokenRequest);
    },
  });
};

